import { render, staticRenderFns } from "./pay-card.vue?vue&type=template&id=0f1af97c&"
import script from "./pay-card.vue?vue&type=script&lang=js&"
export * from "./pay-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports